export const BurgerMenu = (() => {
	// Configuration par défaut
	const defaults = {
		selector: ".burger", // Sélecteur des boutons burger
		stateAttribute: "data-state", // Attribut d'état personnalisé
		expandedAttribute: "aria-expanded", // Attribut d'accessibilité pour l'état
		openState: "opened", // Valeur pour l'état ouvert
		closedState: "closed", // Valeur pour l'état fermé
		openClass: "is-open", // Classe à ajouter lors de l'ouverture
	};

	// Fonction qui gère l'état du bouton burger
	const toggleBurgerState = (button, config) => {
		const currentState = button.getAttribute(config.stateAttribute);
		const targetId = button.getAttribute("aria-controls");

		const target = document.querySelector(`#${targetId}`);

		if (!currentState || currentState === config.closedState) {
			button.setAttribute(config.stateAttribute, config.openState);
			button.setAttribute(config.expandedAttribute, "true");
			target.classList.add(config.openClass);
		} else {
			button.setAttribute(config.stateAttribute, config.closedState);
			button.setAttribute(config.expandedAttribute, "false");
			target.classList.remove(config.openClass);
		}
	};

	// Fonction d'initialisation
	const init = (userOptions = {}) => {
		const config = { ...defaults, ...userOptions }; // Fusion de la config par défaut avec l'option utilisateur

		const buttons = document.querySelectorAll(config.selector);
		buttons.forEach((button) => {
			button.addEventListener("click", (e) => toggleBurgerState(button, config));
		});
	};

	return { init };
})();

// Usage:
// BurgerMenu.init({
// 	selector: ".burger", // Sélecteur des boutons burger
// 	openClass: "menu-visible",  // Classe personnalisée pour ouvrir le menu
// });
